/* tslint:disable */
import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  AmountHumanReadable: string
  BigDecimal: string
  BigInt: string
  Bytes: string
  Date: any
  GqlBigNumber: any
  JSON: any
}

export interface AddStakersInput {
  addresses: Array<Scalars['String']>
  chainId: Scalars['Int']
}

export interface AddressToV2PoolBalanceMap {
  __typename: 'AddressToV2PoolBalanceMap'
  account: Scalars['String']
  balances: Array<ContractBalanceMap>
  totalValueUSD: Scalars['Float']
}

export interface ChainIdInput {
  chainId: Scalars['Int']
}

export interface ContractBalanceMap {
  __typename: 'ContractBalanceMap'
  balance: Scalars['String']
  usdValue?: Maybe<Scalars['Float']>
  v2Pool: GqlPoolV2
}

export interface GetNftPoolArgs {
  address?: InputMaybe<Scalars['String']>
  lpToken?: InputMaybe<Scalars['String']>
}

export interface GetNftPoolsArgs {
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Scalars['String']>
  orderDirection?: InputMaybe<Scalars['String']>
  skip?: InputMaybe<Scalars['Int']>
  where?: InputMaybe<GetNftPoolsWhereInput>
}

export interface GetNftPoolsWhereInput {
  category?: InputMaybe<Array<InputMaybe<GqlPoolFilterCategory>>>
}

export interface GqlPool {
  address: Scalars['String']
  blockNumber: Scalars['Int']
  categories: Array<Maybe<GqlPoolCategory>>
  chainId: Scalars['Int']
  createTime: Scalars['Int']
  decimals?: Maybe<Scalars['Int']>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  swapFee: Scalars['Float']
  symbol?: Maybe<Scalars['String']>
  token0: GqlToken
  token1: GqlToken
}

export interface GqlPoolApr {
  __typename: 'GqlPoolApr'
  hasRewardApr: Scalars['Boolean']
  items: Array<GqlPoolAprItem>
  max?: Maybe<Scalars['Float']>
  min?: Maybe<Scalars['Float']>
  nativeRewardApr: Scalars['Float']
  swapApr: Scalars['Float']
  thirdPartyApr: Scalars['Float']
  total: Scalars['Float']
}

export interface GqlPoolAprItem {
  __typename: 'GqlPoolAprItem'
  apr: Scalars['Float']
  id: Scalars['String']
  poolId: Scalars['String']
  range?: Maybe<GqlPoolAprRange>
  title: Scalars['String']
  type: Scalars['String']
}

export interface GqlPoolAprRange {
  __typename: 'GqlPoolAprRange'
  aprItem: GqlPoolAprItem
  id: Scalars['String']
  max: Scalars['Float']
  min: Scalars['Float']
}

export interface GqlPoolCategory {
  __typename: 'GqlPoolCategory'
  category: Scalars['String']
  id: Scalars['String']
}

export interface GqlPoolFilter {
  categoryIn?: InputMaybe<Array<GqlPoolFilterCategory>>
  categoryNotIn?: InputMaybe<Array<GqlPoolFilterCategory>>
  filterIn?: InputMaybe<Array<Scalars['String']>>
  filterNotIn?: InputMaybe<Array<Scalars['String']>>
  idIn?: InputMaybe<Array<Scalars['String']>>
  idNotIn?: InputMaybe<Array<Scalars['String']>>
  tokensIn?: InputMaybe<Array<Scalars['String']>>
  tokensNotIn?: InputMaybe<Array<Scalars['String']>>
}

export type GqlPoolFilterCategory = 'BLACK_LISTED' | 'COMMUNITY' | 'INCENTIVIZED'

export interface GqlPoolFilterDefinition {
  __typename: 'GqlPoolFilterDefinition'
  id: Scalars['ID']
  title: Scalars['String']
}

export type GqlPoolOrderBy = 'apr' | 'fees24h' | 'totalLiquidity' | 'totalShares' | 'volume24h'

export type GqlPoolOrderDirection = 'asc' | 'desc'

export interface GqlPoolSnapshot {
  __typename: 'GqlPoolSnapshot'
  amounts: Array<Scalars['String']>
  fees24h: Scalars['String']
  holdersCount: Scalars['String']
  id: Scalars['ID']
  poolId: Scalars['String']
  sharePrice: Scalars['String']
  swapsCount: Scalars['String']
  timestamp: Scalars['Int']
  totalLiquidity: Scalars['String']
  totalShares: Scalars['String']
  totalSwapFee: Scalars['String']
  totalSwapVolume: Scalars['String']
  volume24h: Scalars['String']
}

export type GqlPoolSnapshotDataRange =
  | 'ALL_TIME'
  | 'NINETY_DAYS'
  | 'ONE_HUNDRED_EIGHTY_DAYS'
  | 'ONE_YEAR'
  | 'THIRTY_DAYS'

export interface GqlPoolSwapFilter {
  poolIdIn?: InputMaybe<Array<Scalars['String']>>
  tokenInIn?: InputMaybe<Array<Scalars['String']>>
  tokenOutIn?: InputMaybe<Array<Scalars['String']>>
}

export interface GqlPoolV2 extends GqlPool {
  __typename: 'GqlPoolV2'
  address: Scalars['String']
  aprItems: Array<Maybe<GqlPoolAprItem>>
  blockNumber: Scalars['Int']
  categories: Array<Maybe<GqlPoolCategory>>
  chainId: Scalars['Int']
  createTime: Scalars['Int']
  decimals?: Maybe<Scalars['Int']>
  dynamicData?: Maybe<GqlV2PoolDynamicData>
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  nftPool?: Maybe<NftPool>
  swapFee: Scalars['Float']
  symbol?: Maybe<Scalars['String']>
  token0: GqlToken
  token1: GqlToken
}

export interface GqlStaker {
  __typename: 'GqlStaker'
  address: Scalars['String']
  apr: Scalars['Float']
  chainId: Scalars['Int']
  depositFee: Scalars['Float']
  depositToken: GqlToken
  id: Scalars['String']
  rewardPerSecond: Scalars['String']
  rewardToken: GqlToken
  totalDepositAmount: Scalars['Float']
  totalDepositValueUSD: Scalars['Float']
  userData?: Maybe<UserStakingInfo>
}

export interface GqlToken extends GqlTokenBase {
  __typename: 'GqlToken'
  address: Scalars['String']
  chainId: Scalars['Int']
  coingeckoContractAddress?: Maybe<Scalars['String']>
  coingeckoPlatformId?: Maybe<Scalars['String']>
  coingeckoTokenId?: Maybe<Scalars['String']>
  currentPrice?: Maybe<GqlTokenCurrentPrice>
  decimals: Scalars['Int']
  dexscreenPairAddress?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  logoURI?: Maybe<Scalars['String']>
  name: Scalars['String']
  symbol: Scalars['String']
  tradeable: Scalars['Boolean']
  useDexscreener?: Maybe<Scalars['Boolean']>
  usePoolPricing?: Maybe<Scalars['Boolean']>
}

export interface GqlTokenAmountHumanReadable {
  address: Scalars['String']
  amount: Scalars['AmountHumanReadable']
}

export interface GqlTokenBase {
  address: Scalars['String']
  chainId: Scalars['Int']
  decimals: Scalars['Int']
  id?: Maybe<Scalars['String']>
  logoURI?: Maybe<Scalars['String']>
  name: Scalars['String']
  symbol: Scalars['String']
  tradeable: Scalars['Boolean']
}

export type GqlTokenChartDataRange = 'SEVEN_DAY' | 'THIRTY_DAY'

export interface GqlTokenCurrentPrice {
  __typename: 'GqlTokenCurrentPrice'
  price?: Maybe<Scalars['Float']>
}

export interface GqlTokenPrice {
  __typename: 'GqlTokenPrice'
  price: Scalars['Float']
  token: GqlToken
}

export interface GqlTokenPriceChartDataItem {
  __typename: 'GqlTokenPriceChartDataItem'
  id: Scalars['ID']
  price: Scalars['AmountHumanReadable']
  timestamp: Scalars['Int']
}

export type GqlTradeType = 'EXACT_INPUT' | 'EXACT_OUTPUT'

export interface GqlV2PoolDynamicData {
  __typename: 'GqlV2PoolDynamicData'
  apr: GqlPoolApr
  fees24h: Scalars['Float']
  fees24hAth: Scalars['BigDecimal']
  fees24hAthTimestamp: Scalars['Int']
  fees24hAtl: Scalars['BigDecimal']
  fees24hAtlTimestamp: Scalars['Int']
  fees48h: Scalars['BigDecimal']
  holdersCount: Scalars['BigInt']
  lifetimeSwapFees: Scalars['BigDecimal']
  lifetimeVolume: Scalars['BigDecimal']
  lpPrice: Scalars['String']
  poolId: Scalars['ID']
  reserves0: Scalars['String']
  reserves1: Scalars['Float']
  sharePriceAth: Scalars['BigDecimal']
  sharePriceAthTimestamp: Scalars['Int']
  sharePriceAtl: Scalars['BigDecimal']
  sharePriceAtlTimestamp: Scalars['Int']
  swapsCount: Scalars['BigInt']
  totalLiquidity: Scalars['Float']
  totalLiquidity24hAgo: Scalars['BigDecimal']
  totalLiquidityAth: Scalars['BigDecimal']
  totalLiquidityAthTimestamp: Scalars['Int']
  totalLiquidityAtl: Scalars['BigDecimal']
  totalLiquidityAtlTimestamp: Scalars['Int']
  totalShares: Scalars['String']
  totalShares24hAgo: Scalars['BigDecimal']
  volume24h: Scalars['Float']
  volume24hAth: Scalars['BigDecimal']
  volume24hAthTimestamp: Scalars['Int']
  volume24hAtl: Scalars['BigDecimal']
  volume24hAtlTimestamp: Scalars['Int']
  volume48h: Scalars['BigDecimal']
}

export interface GqlV2PoolSwap {
  __typename: 'GqlV2PoolSwap'
  amount0In: Scalars['String']
  amount0Out: Scalars['String']
  amount1In: Scalars['String']
  amount1Out: Scalars['String']
  amountUSD: Scalars['Float']
  blockNumber: Scalars['Int']
  from: Scalars['String']
  id: Scalars['Int']
  pool: GqlPoolV2
  sender: Scalars['String']
  timestamp: Scalars['Int']
  timestampDate: Scalars['String']
  to: Scalars['String']
  tokenAmountIn: Scalars['String']
  tokenAmountOut: Scalars['String']
  tokenIn: Scalars['String']
  tokenInSym: Scalars['String']
  tokenOut: Scalars['String']
  tokenOutSym: Scalars['String']
  tx: Scalars['String']
}

export interface GqlV3Pool extends GqlPool {
  __typename: 'GqlV3Pool'
  address: Scalars['String']
  aprItems: Array<Maybe<GqlPoolAprItem>>
  blockNumber: Scalars['Int']
  categories: Array<Maybe<GqlPoolCategory>>
  chainId: Scalars['Int']
  createTime: Scalars['Int']
  decimals?: Maybe<Scalars['Int']>
  dynamicData?: Maybe<GqlV3PoolDynamicData>
  feeTier: Scalars['Int']
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  slot0: GqlV3PoolSlotZeroData
  swapFee: Scalars['Float']
  symbol?: Maybe<Scalars['String']>
  token0: GqlToken
  token1: GqlToken
}

export interface GqlV3PoolDynamicData {
  __typename: 'GqlV3PoolDynamicData'
  blockNumber: Scalars['Int']
  liquidity: Scalars['String']
  totalLiquidity: Scalars['Float']
}

export interface GqlV3PoolSlotZeroData {
  __typename: 'GqlV3PoolSlotZeroData'
  feeProtocol: Scalars['Int']
  sqrtPriceX96: Scalars['String']
  tick?: Maybe<Scalars['Int']>
}

export interface Mutation {
  __typename: 'Mutation'
  addStakers: Scalars['String']
  chainId: Scalars['Int']
  initSubgraphV2PoolsSync: Scalars['String']
  loadSnapshotsForAllPools: Array<Maybe<Scalars['String']>>
  setQuoteTokens: Scalars['String']
  syncAllTokenLists: Scalars['String']
  syncLatestSnapshotsForV2AllPools: Array<Maybe<Scalars['String']>>
  syncMasterChefInfo: Scalars['String']
  syncNFTPools: Scalars['String']
  syncNewV2PoolsFromSubgraph: Scalars['String']
  syncNewV3PoolsFromSubgraph: Scalars['String']
  syncProtocolMetrics: Scalars['String']
  syncStakers: Scalars['String']
  syncSwapsForLast48Hours: Array<Maybe<Scalars['String']>>
  syncTokenList: Scalars['String']
  syncTokenPrices: Scalars['String']
  syncV3PoolsDynamicData: Scalars['String']
  syncV3SwapsForLast48Hours: Array<Maybe<Scalars['String']>>
  updateLiquidityValuesForV2Pools: Scalars['String']
  updateLiquidityValuesForV3Pools: Scalars['String']
  updateSwapAprForV2Pools: Scalars['String']
  updateSwapAprForV3Pools: Scalars['String']
  updateV2FarmAprs: Scalars['String']
  updateVolumeAndFeeValuesForAllV2Pools: Scalars['String']
  updateVolumeAndFeeValuesForAllV3Pools: Scalars['String']
}

export interface MutationAddStakersArgs {
  input: AddStakersInput
}

export interface MutationInitSubgraphV2PoolsSyncArgs {
  chainId: Scalars['Int']
}

export interface MutationLoadSnapshotsForAllPoolsArgs {
  chainId: Scalars['Int']
}

export interface MutationSetQuoteTokensArgs {
  chainId: Scalars['Int']
  setTrue: Scalars['Boolean']
  tokens: Array<Scalars['String']>
}

export interface MutationSyncLatestSnapshotsForV2AllPoolsArgs {
  chainId: Scalars['Int']
}

export interface MutationSyncMasterChefInfoArgs {
  chainId: Scalars['Int']
}

export interface MutationSyncNftPoolsArgs {
  chainId: Scalars['Int']
}

export interface MutationSyncNewV2PoolsFromSubgraphArgs {
  chainId: Scalars['Int']
}

export interface MutationSyncNewV3PoolsFromSubgraphArgs {
  chainId: Scalars['Int']
}

export interface MutationSyncProtocolMetricsArgs {
  chainId: Scalars['Int']
}

export interface MutationSyncStakersArgs {
  chainId: Scalars['Int']
}

export interface MutationSyncSwapsForLast48HoursArgs {
  chainId: Scalars['Int']
}

export interface MutationSyncTokenListArgs {
  args: ChainIdInput
}

export interface MutationSyncTokenPricesArgs {
  chainId: Scalars['Int']
}

export interface MutationSyncV3PoolsDynamicDataArgs {
  chainId: Scalars['Int']
}

export interface MutationSyncV3SwapsForLast48HoursArgs {
  chainId: Scalars['Int']
}

export interface MutationUpdateLiquidityValuesForV2PoolsArgs {
  chainId: Scalars['Int']
}

export interface MutationUpdateLiquidityValuesForV3PoolsArgs {
  chainId: Scalars['Int']
}

export interface MutationUpdateSwapAprForV2PoolsArgs {
  chainId: Scalars['Int']
}

export interface MutationUpdateSwapAprForV3PoolsArgs {
  chainId: Scalars['Int']
}

export interface MutationUpdateV2FarmAprsArgs {
  chainId: Scalars['Int']
}

export interface MutationUpdateVolumeAndFeeValuesForAllV2PoolsArgs {
  chainId: Scalars['Int']
}

export interface MutationUpdateVolumeAndFeeValuesForAllV3PoolsArgs {
  chainId: Scalars['Int']
}

export interface NftPool {
  __typename: 'NFTPool'
  address: Scalars['String']
  allocPoints: Scalars['Int']
  allocPointsWETH: Scalars['Int']
  aprInfo: NftPoolAprInfo
  chainId: Scalars['Int']
  id: Scalars['ID']
  lastRewardTime: Scalars['Int']
  lpSupply: Scalars['Float']
  lpSupplyWithMultiplier: Scalars['Float']
  lpToken: Scalars['String']
  maxBoostMultiplier: Scalars['Int']
  maxGlobalMultiplier: Scalars['Int']
  maxLockDuration: Scalars['Int']
  maxLockMultiplier: Scalars['Int']
  poolEmissionRate: Scalars['Float']
  poolEmissionRateWETH: Scalars['Float']
  positions: Array<Maybe<NftPoolPosition>>
  reserve: Scalars['String']
  reserveWETH: Scalars['String']
  tokenIds: Array<Maybe<Scalars['Int']>>
  userAllowance: Scalars['String']
  userLpBalance: Scalars['String']
  v2Pool: GqlPoolV2
  xTokenRewardsShare: Scalars['Int']
}

export interface NftPoolAprInfo {
  __typename: 'NFTPoolAprInfo'
  apr: Scalars['Float']
  maxApr: Scalars['Float']
  maxBoostApr: Scalars['Float']
  maxLockApr: Scalars['Float']
  swapFeeApr: Scalars['Float']
}

export interface NftPoolPosition {
  __typename: 'NFTPoolPosition'
  amount: Scalars['String']
  amountWithMultiplier: Scalars['String']
  aprInfo?: Maybe<NftPositionAprs>
  boostPoints: Scalars['Float']
  hasActiveLock: Scalars['Boolean']
  id: Scalars['ID']
  lockDuration: Scalars['Int']
  lockEndDateLabel: Scalars['String']
  lockMultiplier: Scalars['Float']
  nftPool: NftPool
  pendingRewards: Array<Maybe<NftPoolPositionReward>>
  pendingRewardsValueUSD: Scalars['Float']
  positionValueUsd: Scalars['Float']
  startLockTime: Scalars['Int']
  tokenId: Scalars['Int']
  totalMultiplier: Scalars['Float']
}

export interface NftPoolPositionReward {
  __typename: 'NFTPoolPositionReward'
  pendingRewards: Scalars['Float']
  token: GqlToken
  usdValue: Scalars['Float']
}

export interface NftPositionAprs {
  __typename: 'NFTPositionAprs'
  lockAprBoost: Scalars['Float']
  totalApr: Scalars['Float']
  yieldBoosterBoostApr: Scalars['Float']
}

export interface PoolWhereInput {
  addresses: Array<InputMaybe<Scalars['String']>>
  chainId: Scalars['Int']
}

export interface Pool_Filter {
  first?: InputMaybe<Scalars['Int']>
  skip?: InputMaybe<Scalars['Int']>
  where?: InputMaybe<PoolWhereInput>
}

export interface ProtocolMetrics {
  __typename: 'ProtocolMetrics'
  date: Scalars['Int']
  dateLabel: Scalars['String']
  poolCount: Scalars['Float']
  swapFee24h: Scalars['String']
  swapVolume24h: Scalars['String']
  totalLiquidity: Scalars['String']
  totalSwapFee: Scalars['String']
  totalSwapVolume: Scalars['String']
}

export interface Query {
  __typename: 'Query'
  getNFTPool?: Maybe<NftPool>
  getNFTPools: Array<Maybe<NftPool>>
  getProtocolTokenPrice: Scalars['Float']
  getStakers: Array<Maybe<GqlStaker>>
  getTokenPrices: Array<Maybe<GqlTokenPrice>>
  getTokens: Array<Maybe<GqlToken>>
  getUserNFTPoolPositions: Array<Maybe<NftPool>>
  getUserV2PoolBalances?: Maybe<ContractBalanceMap>
  getUserV2PoolWalletBalances?: Maybe<AddressToV2PoolBalanceMap>
  getV2PoolSwaps: Array<Maybe<GqlV2PoolSwap>>
  getV2Pools: Array<Maybe<GqlPoolV2>>
  getV2PoolsWithFarms: Array<Maybe<GqlPoolV2>>
  getV2PoolsWithLiquidityCount: Scalars['Int']
  getV2Quote?: Maybe<V2QuoteResponse>
  getV3Pools: Array<Maybe<GqlV3Pool>>
  poolGetPool?: Maybe<GqlPoolV2>
  poolGetPoolFilters: Array<GqlPoolFilterDefinition>
  poolGetPools: Array<GqlPoolV2>
  poolGetPoolsCount: Scalars['Int']
  poolGetSnapshots: Array<GqlPoolSnapshot>
  poolGetSwaps: Array<GqlV2PoolSwap>
  protocolMetrics: ProtocolMetrics
  protocolV2Metrics: ProtocolMetrics
  protocolV3Metrics: ProtocolMetrics
  tokenGetRelativePriceChartData: Array<GqlTokenPriceChartDataItem>
  tokenGetTokenData?: Maybe<GqlToken>
  tokenGetTokensData: Array<GqlToken>
  userGetStaking: Array<Maybe<GqlStaker>>
}

export interface QueryGetNftPoolArgs {
  args: GetNftPoolArgs
}

export interface QueryGetNftPoolsArgs {
  chainId: Scalars['Int']
  onlyWithAllocation?: InputMaybe<Scalars['Boolean']>
}

export interface QueryGetProtocolTokenPriceArgs {
  chainId: Scalars['Int']
}

export interface QueryGetStakersArgs {
  chainId: Scalars['Int']
}

export interface QueryGetTokenPricesArgs {
  chainId?: InputMaybe<Scalars['Int']>
}

export interface QueryGetTokensArgs {
  chainId?: InputMaybe<Scalars['Int']>
}

export interface QueryGetUserNftPoolPositionsArgs {
  account: Scalars['String']
  chainId: Scalars['Int']
}

export interface QueryGetUserV2PoolBalancesArgs {
  account?: InputMaybe<Scalars['String']>
  chainId: Scalars['Int']
  first?: InputMaybe<Scalars['Int']>
  skip?: InputMaybe<Scalars['Int']>
}

export interface QueryGetUserV2PoolWalletBalancesArgs {
  account?: InputMaybe<Scalars['String']>
  chainId: Scalars['Int']
}

export interface QueryGetV2PoolSwapsArgs {
  chainId: Scalars['Int']
  limit?: InputMaybe<Scalars['Int']>
  pools: Array<Scalars['String']>
}

export interface QueryGetV2PoolsArgs {
  chainId: Scalars['Int']
}

export interface QueryGetV2PoolsWithFarmsArgs {
  chainId: Scalars['Int']
}

export interface QueryGetV2PoolsWithLiquidityCountArgs {
  chainId: Scalars['Int']
}

export interface QueryGetV2QuoteArgs {
  args: V2QuoteInput
}

export interface QueryGetV3PoolsArgs {
  chainId: Scalars['Int']
}

export interface QueryPoolGetPoolArgs {
  poolId: Scalars['String']
}

export interface QueryPoolGetPoolsArgs {
  chainId: Scalars['Int']
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<GqlPoolOrderBy>
  orderDirection?: InputMaybe<GqlPoolOrderDirection>
  skip?: InputMaybe<Scalars['Int']>
  textSearch?: InputMaybe<Scalars['String']>
  where?: InputMaybe<GqlPoolFilter>
}

export interface QueryPoolGetPoolsCountArgs {
  chainId: Scalars['Int']
  first?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<GqlPoolOrderBy>
  orderDirection?: InputMaybe<GqlPoolOrderDirection>
  skip?: InputMaybe<Scalars['Int']>
  textSearch?: InputMaybe<Scalars['String']>
  where?: InputMaybe<GqlPoolFilter>
}

export interface QueryPoolGetSnapshotsArgs {
  id: Scalars['String']
  range: GqlPoolSnapshotDataRange
}

export interface QueryPoolGetSwapsArgs {
  first?: InputMaybe<Scalars['Int']>
  skip?: InputMaybe<Scalars['Int']>
  where?: InputMaybe<GqlPoolSwapFilter>
}

export interface QueryProtocolMetricsArgs {
  chainId?: InputMaybe<Scalars['Int']>
}

export interface QueryProtocolV2MetricsArgs {
  chainId?: InputMaybe<Scalars['Int']>
}

export interface QueryProtocolV3MetricsArgs {
  chainId?: InputMaybe<Scalars['Int']>
}

export interface QueryTokenGetRelativePriceChartDataArgs {
  range: GqlTokenChartDataRange
  tokenIn: Scalars['String']
  tokenOut: Scalars['String']
}

export interface QueryTokenGetTokenDataArgs {
  address: Scalars['String']
  chainId: Scalars['Int']
}

export interface QueryTokenGetTokensDataArgs {
  addresses: Array<Scalars['String']>
  chainId: Scalars['Int']
}

export interface QueryUserGetStakingArgs {
  account?: InputMaybe<Scalars['String']>
  chainId: Scalars['Int']
}

export interface SwapOptionsInput {
  maxHops?: InputMaybe<Scalars['Int']>
}

export interface SwapResult {
  __typename: 'SwapResult'
  amount: Scalars['String']
  poolId: Scalars['String']
}

export interface SwapRoute {
  __typename: 'SwapRoute'
  hops?: Maybe<Array<Maybe<SwapRouteHop>>>
  tokenIn: Scalars['String']
  tokenInAmount: Scalars['String']
  tokenOut: Scalars['String']
  tokenOutAmount: Scalars['String']
}

export interface SwapRouteHop {
  __typename: 'SwapRouteHop'
  pool: GqlPoolV2
  poolId: Scalars['String']
  tokenIn: Scalars['String']
  tokenInAmount: Scalars['String']
  tokenOut: Scalars['String']
  tokenOutAmount: Scalars['String']
}

export interface UserDataQueryArgs {
  account: Scalars['String']
  chainId: Scalars['Int']
  refetch?: InputMaybe<Scalars['Boolean']>
}

export interface UserStakingInfo {
  __typename: 'UserStakingInfo'
  depositTokenBalance: Scalars['String']
  pendingRewardAmount: Scalars['Float']
  pendingRewardValue: Scalars['Float']
  poolAllowance: Scalars['String']
  stakedBalance: Scalars['String']
  stakedBalanceValue: Scalars['String']
}

export interface V2QuoteInput {
  chainId: Scalars['Int']
  swapAmount: Scalars['String']
  swapOptions?: InputMaybe<SwapOptionsInput>
  swapType: GqlTradeType
  tokenIn: Scalars['String']
  tokenOut: Scalars['String']
}

export interface V2QuoteResponse {
  __typename: 'V2QuoteResponse'
  priceImpact?: Maybe<Scalars['String']>
  returnAmount?: Maybe<Scalars['String']>
  routes: Array<Maybe<SwapRoute>>
  swapAmount?: Maybe<Scalars['String']>
  swapType: GqlTradeType
  swaps: Array<Maybe<SwapResult>>
  tokenIn: Scalars['String']
  tokenOut: Scalars['String']
}

export type GqlTokenFragmentFragment = {
  __typename: 'GqlToken'
  symbol: string
  address: string
  currentPrice?: { __typename: 'GqlTokenCurrentPrice'; price?: number | null } | null
}

export type AprItemFragmentFragment = { __typename: 'GqlPoolAprItem'; type: string; apr: number }

export type GetTokenPricesQueryVariables = Exact<{
  chainId: Scalars['Int']
}>

export type GetTokenPricesQuery = {
  __typename: 'Query'
  getTokenPrices: Array<{
    __typename: 'GqlTokenPrice'
    price: number
    token: { __typename: 'GqlToken'; address: string; symbol: string }
  } | null>
}

export type GetNftPoolsQueryVariables = Exact<{
  chainId: Scalars['Int']
  onlyWithAllocation?: InputMaybe<Scalars['Boolean']>
}>

export type GetNftPoolsQuery = {
  __typename: 'Query'
  getNFTPools: Array<{
    __typename: 'NFTPool'
    address: string
    lpSupply: number
    lpSupplyWithMultiplier: number
    allocPoints: number
    allocPointsWETH: number
    poolEmissionRate: number
    poolEmissionRateWETH: number
    xTokenRewardsShare: number
    maxGlobalMultiplier: number
    maxLockDuration: number
    maxLockMultiplier: number
    maxBoostMultiplier: number
    aprInfo: {
      __typename: 'NFTPoolAprInfo'
      apr: number
      maxBoostApr: number
      maxLockApr: number
      maxApr: number
      swapFeeApr: number
    }
    v2Pool: {
      __typename: 'GqlPoolV2'
      address: string
      symbol?: string | null
      token0: {
        __typename: 'GqlToken'
        symbol: string
        address: string
        currentPrice?: { __typename: 'GqlTokenCurrentPrice'; price?: number | null } | null
      }
      token1: {
        __typename: 'GqlToken'
        symbol: string
        address: string
        currentPrice?: { __typename: 'GqlTokenCurrentPrice'; price?: number | null } | null
      }
      aprItems: Array<{ __typename: 'GqlPoolAprItem'; type: string; apr: number } | null>
    }
  } | null>
}

export type GetStakersQueryVariables = Exact<{
  chainId: Scalars['Int']
  account?: InputMaybe<Scalars['String']>
}>

export type GetStakersQuery = {
  __typename: 'Query'
  userGetStaking: Array<{
    __typename: 'GqlStaker'
    address: string
    totalDepositAmount: number
    rewardPerSecond: string
    totalDepositValueUSD: number
    apr: number
    depositFee: number
    depositToken: {
      __typename: 'GqlToken'
      symbol: string
      address: string
      currentPrice?: { __typename: 'GqlTokenCurrentPrice'; price?: number | null } | null
    }
    rewardToken: {
      __typename: 'GqlToken'
      symbol: string
      address: string
      currentPrice?: { __typename: 'GqlTokenCurrentPrice'; price?: number | null } | null
    }
    userData?: {
      __typename: 'UserStakingInfo'
      poolAllowance: string
      depositTokenBalance: string
      stakedBalance: string
      stakedBalanceValue: string
      pendingRewardAmount: number
      pendingRewardValue: number
    } | null
  } | null>
}

export type GetV2PoolsQueryVariables = Exact<{
  chainId: Scalars['Int']
}>

export type GetV2PoolsQuery = {
  __typename: 'Query'
  getV2Pools: Array<{
    __typename: 'GqlPoolV2'
    address: string
    aprItems: Array<{ __typename: 'GqlPoolAprItem'; type: string; apr: number } | null>
  } | null>
}

export const GqlTokenFragmentFragmentDoc = gql`
  fragment GqlTokenFragment on GqlToken {
    symbol
    address
    currentPrice {
      price
    }
  }
`
export const AprItemFragmentFragmentDoc = gql`
  fragment AprItemFragment on GqlPoolAprItem {
    type
    apr
  }
`
export const GetTokenPricesDocument = gql`
  query GetTokenPrices($chainId: Int!) {
    getTokenPrices(chainId: $chainId) {
      price
      token {
        address
        symbol
      }
    }
  }
`

/**
 * __useGetTokenPricesQuery__
 *
 * To run a query within a React component, call `useGetTokenPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTokenPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTokenPricesQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useGetTokenPricesQuery(
  baseOptions: Apollo.QueryHookOptions<GetTokenPricesQuery, GetTokenPricesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTokenPricesQuery, GetTokenPricesQueryVariables>(GetTokenPricesDocument, options)
}
export function useGetTokenPricesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTokenPricesQuery, GetTokenPricesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTokenPricesQuery, GetTokenPricesQueryVariables>(GetTokenPricesDocument, options)
}
export type GetTokenPricesQueryHookResult = ReturnType<typeof useGetTokenPricesQuery>
export type GetTokenPricesLazyQueryHookResult = ReturnType<typeof useGetTokenPricesLazyQuery>
export type GetTokenPricesQueryResult = Apollo.QueryResult<GetTokenPricesQuery, GetTokenPricesQueryVariables>
export const GetNftPoolsDocument = gql`
  query GetNFTPools($chainId: Int!, $onlyWithAllocation: Boolean) {
    getNFTPools(chainId: $chainId, onlyWithAllocation: $onlyWithAllocation) {
      address
      lpSupply
      lpSupplyWithMultiplier
      allocPoints
      allocPointsWETH
      poolEmissionRate
      poolEmissionRateWETH
      xTokenRewardsShare
      maxGlobalMultiplier
      maxLockDuration
      maxLockMultiplier
      maxBoostMultiplier
      aprInfo {
        apr
        maxBoostApr
        maxLockApr
        maxApr
        swapFeeApr
      }
      v2Pool {
        address
        symbol
        token0 {
          ...GqlTokenFragment
        }
        token1 {
          ...GqlTokenFragment
        }
        aprItems {
          ...AprItemFragment
        }
      }
    }
  }
  ${GqlTokenFragmentFragmentDoc}
  ${AprItemFragmentFragmentDoc}
`

/**
 * __useGetNftPoolsQuery__
 *
 * To run a query within a React component, call `useGetNftPoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNftPoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNftPoolsQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *      onlyWithAllocation: // value for 'onlyWithAllocation'
 *   },
 * });
 */
export function useGetNftPoolsQuery(baseOptions: Apollo.QueryHookOptions<GetNftPoolsQuery, GetNftPoolsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetNftPoolsQuery, GetNftPoolsQueryVariables>(GetNftPoolsDocument, options)
}
export function useGetNftPoolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNftPoolsQuery, GetNftPoolsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetNftPoolsQuery, GetNftPoolsQueryVariables>(GetNftPoolsDocument, options)
}
export type GetNftPoolsQueryHookResult = ReturnType<typeof useGetNftPoolsQuery>
export type GetNftPoolsLazyQueryHookResult = ReturnType<typeof useGetNftPoolsLazyQuery>
export type GetNftPoolsQueryResult = Apollo.QueryResult<GetNftPoolsQuery, GetNftPoolsQueryVariables>
export const GetStakersDocument = gql`
  query GetStakers($chainId: Int!, $account: String) {
    userGetStaking(chainId: $chainId, account: $account) {
      address
      totalDepositAmount
      rewardPerSecond
      totalDepositValueUSD
      apr
      depositFee
      depositToken {
        ...GqlTokenFragment
      }
      rewardToken {
        ...GqlTokenFragment
      }
      userData {
        poolAllowance
        depositTokenBalance
        stakedBalance
        stakedBalanceValue
        pendingRewardAmount
        pendingRewardValue
      }
    }
  }
  ${GqlTokenFragmentFragmentDoc}
`

/**
 * __useGetStakersQuery__
 *
 * To run a query within a React component, call `useGetStakersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStakersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStakersQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useGetStakersQuery(baseOptions: Apollo.QueryHookOptions<GetStakersQuery, GetStakersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetStakersQuery, GetStakersQueryVariables>(GetStakersDocument, options)
}
export function useGetStakersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetStakersQuery, GetStakersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetStakersQuery, GetStakersQueryVariables>(GetStakersDocument, options)
}
export type GetStakersQueryHookResult = ReturnType<typeof useGetStakersQuery>
export type GetStakersLazyQueryHookResult = ReturnType<typeof useGetStakersLazyQuery>
export type GetStakersQueryResult = Apollo.QueryResult<GetStakersQuery, GetStakersQueryVariables>
export const GetV2PoolsDocument = gql`
  query GetV2Pools($chainId: Int!) {
    getV2Pools(chainId: $chainId) {
      address
      aprItems {
        type
        apr
      }
    }
  }
`

/**
 * __useGetV2PoolsQuery__
 *
 * To run a query within a React component, call `useGetV2PoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetV2PoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetV2PoolsQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *   },
 * });
 */
export function useGetV2PoolsQuery(baseOptions: Apollo.QueryHookOptions<GetV2PoolsQuery, GetV2PoolsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetV2PoolsQuery, GetV2PoolsQueryVariables>(GetV2PoolsDocument, options)
}
export function useGetV2PoolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetV2PoolsQuery, GetV2PoolsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetV2PoolsQuery, GetV2PoolsQueryVariables>(GetV2PoolsDocument, options)
}
export type GetV2PoolsQueryHookResult = ReturnType<typeof useGetV2PoolsQuery>
export type GetV2PoolsLazyQueryHookResult = ReturnType<typeof useGetV2PoolsLazyQuery>
export type GetV2PoolsQueryResult = Apollo.QueryResult<GetV2PoolsQuery, GetV2PoolsQueryVariables>
